<template>
  <div class="container-toast-manager">
    <transition-group name="toast-fade-in" mode="out-in" appear>
      <div class="toast-wrapper" v-for="(message, index) in toastMessages" :key="message">
        <toast-item :message="toastMessages[index]"
                    :remove-toast-item-func="removeToastItem"/>
      </div>
    </transition-group>
  </div>
</template>

<script>
import Vue from 'vue';
import ToastItem from './components/ToastItem';

export default {
  name: 'ToastManager',
  data() {
    return {
      toastMessages: [],
    };
  },
  methods: {
    addToastItem(message) {
      this.toastMessages.push(message);
    },
    removeToastItem() {
      this.toastMessages.shift();
    },
  },
  created() {
    const EventBus = new Vue();

    EventBus.addToastItem = this.addToastItem;

    Object.defineProperties(Vue.prototype, {
      $toast: {
        get: () => (message) => {
          EventBus.addToastItem(message);
        },
        configurable: false,
      },
    });
  },
  components: {
    ToastItem,
  },
};

</script>

<style lang="scss" scoped>
.toast-fade-in-enter-active, .toast-fade-in-leave-active {
  transition: all 0.5s;
}
.toast-fade-in-enter {
  opacity: 0;
  transform: translateY(24px);
}
.toast-fade-in-leave-to {
  opacity: 0;
}

.container-toast-manager {
  position: fixed;
  z-index: 5000;

  bottom: 48px;
  right: 64px;

  width: auto;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-content: flex-end;
  align-items: flex-end;

  .toast-wrapper {
    width: 100%;
  }
}

@media screen and (max-width: 1024px) {
  .container-toast-manager {
    right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/toast/ToastManager.vue